// import React, { useState, useEffect, useRef } from 'react';
// import logo from '../assets/logo192.png';
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { NotificationManager } from 'react-notifications';
// import 'react-notifications/lib/notifications.css';
// import {jwtDecode} from 'jwt-decode';

// const Navbar = () => {
//   const navigate = useNavigate();
//   const dropdownRef = useRef(null); // Ref for dropdown
//   const BaseUrl = process.env.REACT_APP_BASE_URL;
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [userName, setUserName] = useState('');

//   useEffect(() => {
//     const validateToken = async () => {
//       try {
//         const jwtToken = localStorage.getItem("authToken");
//         if (!jwtToken) {
//           throw new Error("JWT token not found in local storage");
//         }
//         // Decode the JWT token to get the username
//         const decodedToken = jwtDecode(jwtToken);
//         const username = decodedToken.name; 
//         setUserName(username); // Set the username

//         const response = await axios.post(`${BaseUrl}/validate-token`, {
//           token: jwtToken,
//         });
//         if (!response.data.valid) {
//           throw new Error("Token validation failed");
//         } else {
//           setIsLoggedIn(true);
//         }
//       } catch (error) {
//         console.error("Error validating token:", error);
//         navigate("/login");
//       }
//     };

//     validateToken();
//   }, [navigate]);

//   // Toggle dropdown state
//   const toggleDropdown = () => {
//     setDropdownOpen(!dropdownOpen);
//   };

//   // Close dropdown if clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setDropdownOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const handleLogout = async () => {
//     try {
//       const jwtToken = localStorage.getItem("authToken");

//       await axios.post(
//         `${BaseUrl}/logoutAdmin`,
//         {}, // pass an empty object as the second argument if no data is needed
//         {
//           headers: {
//             Authorization: `Bearer ${jwtToken}`,
//           },
//         }
//       );
//       localStorage.removeItem("authToken");
//       navigate("/login");
//       NotificationManager.success('Logout Successful!', '', 5000);
//     } catch (error) {
//       console.error("Logout failed:", error);
//     }
//   };

//   return (
//     <nav className="navbar navbar-dark fixed-top" style={{ backgroundColor: '#03041c' }}>
//       <div className="container d-flex justify-content-between align-items-center">
//         <a className="navbar-brand" href="#">
//           <img
//             src={logo}
//             height="40"
//             alt="Blueaster Logo"
//             loading="lazy"
//           />
//         </a>
//         {isLoggedIn ? (
//           <div className="dropdown" ref={dropdownRef}>
//         <button
//         // className="btn btn-secondary custom-btn"
//         className="btn btn-outline-primary fw-bold subbtn dropdown-toggle"
//         type="button"
//         id="dropdownMenuButton"
//         onClick={toggleDropdown}
//         >
//         <span className="welcome-text">Welcome {userName}</span>
//         </button>

//             {dropdownOpen && (
//               <ul className="dropdown-menu dropdown-menu-end show" aria-labelledby="dropdownMenuButton">
//                 <li>
//                   <button className="dropdown-item" onClick={handleLogout}>
//                     Logout
//                   </button>
//                 </li>
//               </ul>
//             )}
//           </div>
//         ) : (
//           ''
//         )}
//       </div>
//     </nav>
//   );
// };

// export default Navbar;

// import React, { useState, useEffect, useRef } from 'react';
// import logo from '../assets/logo192.png';
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { NotificationManager } from 'react-notifications';
// import 'react-notifications/lib/notifications.css';
// import { jwtDecode } from 'jwt-decode';

// const Navbar = () => {
//   const navigate = useNavigate();
//   const dropdownRef = useRef(null); // Ref for dropdown
//   const BaseUrl = process.env.REACT_APP_BASE_URL;
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [userName, setUserName] = useState('');

//   useEffect(() => {
//     const validateToken = async () => {
//       try {
//         const jwtToken = localStorage.getItem("authToken");
//         if (!jwtToken) {
//           throw new Error("JWT token not found in local storage");
//         }
//         // Decode the JWT token to get the username
//         const decodedToken = jwtDecode(jwtToken);
//         const username = decodedToken.name;
//         setUserName(username); // Set the username

//         const response = await axios.post(`${BaseUrl}/validate-token`, {
//           token: jwtToken,
//         });
//         if (!response.data.valid) {
//           throw new Error("Token validation failed");
//         } else {
//           setIsLoggedIn(true);
//         }
//       } catch (error) {
//         console.error("Error validating token:", error);
//         navigate("/login");
//       }
//     };

//     validateToken();
//   }, [navigate]);

//   // Toggle dropdown state
//   const toggleDropdown = () => {
//     setDropdownOpen(!dropdownOpen);
//   };

//   // Close dropdown if clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setDropdownOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const handleLogout = async () => {
//     try {
//       const jwtToken = localStorage.getItem("authToken");

//       await axios.post(
//         `${BaseUrl}/logoutAdmin`,
//         {}, // pass an empty object as the second argument if no data is needed
//         {
//           headers: {
//             Authorization: `Bearer ${jwtToken}`,
//           },
//         }
//       );
//       localStorage.removeItem("authToken");
//       navigate("/login");
//       NotificationManager.success('Logout Successful!', '', 5000);
//     } catch (error) {
//       console.error("Logout failed:", error);
//     }
//   };

//   return (
//     <nav className="navbar navbar-dark" style={{ backgroundColor: '#03041c' }}>
//       <div className="container d-flex justify-content-between align-items-center">
//         <a className="navbar-brand" href="#">
//           <img
//             src={logo}
//             height="40"
//             alt="Blueaster Logo"
//             loading="lazy"
//           />
//         </a>
//         {isLoggedIn ? (
//           <div className="dropdown" ref={dropdownRef}>
//             <button
//               className="btn btn-outline-primary fw-bold subbtn dropdown-toggle"
//               type="button"
//               id="dropdownMenuButton"
//               onClick={toggleDropdown}
//             >
//               <span className="welcome-text">Welcome {userName}</span>
//             </button>

//             {dropdownOpen && (
//               <ul className="dropdown-menu dropdown-menu-end show" aria-labelledby="dropdownMenuButton">
//                 <li>
//                   <button className="dropdown-item" onClick={handleLogout}>
//                     Logout
//                   </button>
//                 </li>
//               </ul>
//             )}
//           </div>
//         ) : null}
//       </div>
//     </nav>
//   );
// };

// export default Navbar;



// import React, { useState, useEffect, useRef } from 'react';
// import logo from '../assets/logo192.png';
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { NotificationManager } from 'react-notifications';
// import 'react-notifications/lib/notifications.css';
// import { jwtDecode } from 'jwt-decode';

// const Navbar = () => {
//   const navigate = useNavigate();
//   const dropdownRef = useRef(null); // Ref for dropdown
//   const BaseUrl = process.env.REACT_APP_BASE_URL;
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [userName, setUserName] = useState('');

//   useEffect(() => {
//     const validateToken = async () => {
//       try {
//         const jwtToken = localStorage.getItem("authToken");
//         if (!jwtToken) {
//           throw new Error("JWT token not found in local storage");
//         }
//         // Decode the JWT token to get the username
//         const decodedToken = jwtDecode(jwtToken);
//         const username = decodedToken.name;
//         setUserName(username); // Set the username

//         const response = await axios.post(`${BaseUrl}/validate-token`, {
//           token: jwtToken,
//         });
//         if (!response.data.valid) {
//           throw new Error("Token validation failed");
//         } else {
//           setIsLoggedIn(true);
//         }
//       } catch (error) {
//         console.error("Error validating token:", error);
//         navigate("/login");
//       }
//     };

//     validateToken();
//   }, [navigate]);

//   // Toggle dropdown state
//   const toggleDropdown = () => {
//     setDropdownOpen(!dropdownOpen);
//   };

//   // Close dropdown if clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setDropdownOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const handleLogout = async () => {
//     try {
//       const jwtToken = localStorage.getItem("authToken");

//       await axios.post(
//         `${BaseUrl}/logoutAdmin`,
//         {}, // pass an empty object as the second argument if no data is needed
//         {
//           headers: {
//             Authorization: `Bearer ${jwtToken}`,
//           },
//         }
//       );
//       localStorage.removeItem("authToken");
//       navigate("/login");
//       NotificationManager.success('Logout Successful!', '', 5000);
//     } catch (error) {
//       console.error("Logout failed:", error);
//     }
//   };

//   return (
//     <nav className="navbar navbar-dark fixed-top" style={{ backgroundColor: 'rgb(14, 34, 61)', zIndex: 999 }}>
//       <div className="container d-flex justify-content-between align-items-center">
//         <a className="navbar-brand" href="/">
//           <img
//             src={logo}
//             height="40"
//             alt="Blueaster Logo"
//             loading="lazy"
//           />
//         </a>
//         {isLoggedIn ? (
//           <div className="dropdown" ref={dropdownRef}>
//             <button
//               className="btn btn-outline-primary fw-bold subbtn dropdown-toggle"
//               type="button"
//               id="dropdownMenuButton"
//               onClick={toggleDropdown}
//               style={{ color: 'white' }}
//             >
//               <span className="welcome-text">Welcome {userName}</span>
//             </button>

//             {dropdownOpen && (
//               <ul className="dropdown-menu dropdown-menu-end show" aria-labelledby="dropdownMenuButton">
//                 <li>
//                   <button className="dropdown-item" onClick={handleLogout}>
//                     Logout
//                   </button>
//                 </li>
//               </ul>
//             )}
//           </div>
//         ) : null}
//       </div>
//     </nav>
//   );
// };

// export default Navbar;


import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { jwtDecode } from 'jwt-decode';

const Navbar = () => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null); // Ref for dropdown
  const BaseUrl = process.env.REACT_APP_BASE_URL;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const validateToken = async () => {
      try {
        const jwtToken = localStorage.getItem("authToken");
        if (!jwtToken) {
          throw new Error("JWT token not found in local storage");
        }
        // Decode the JWT token to get the username
        const decodedToken = jwtDecode(jwtToken);
        const username = decodedToken.name;
        setUserName(username); // Set the username

        const response = await axios.post(`${BaseUrl}/validate-token`, {
          token: jwtToken,
        });
        if (!response.data.valid) {
          throw new Error("Token validation failed");
        } else {
          setIsLoggedIn(true);
        }
      } catch (error) {
        console.error("Error validating token:", error);
        navigate("/login");
      }
    };

    validateToken();
  }, [navigate]);

  // Toggle dropdown state
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Close dropdown if clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    try {
      const jwtToken = localStorage.getItem("authToken");

      await axios.post(
        `${BaseUrl}/logoutAdmin`,
        {}, // pass an empty object as the second argument if no data is needed
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      localStorage.removeItem("authToken");
      navigate("/login");
      NotificationManager.success('Logout Successful!', '', 5000);
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <nav className="navbar navbar-dark fixed-top" style={{ backgroundColor: 'rgb(14, 34, 61)', zIndex: 999 }}>
      <div className="container d-flex justify-content-end align-items-center">
        {isLoggedIn ? (
          <div className="dropdown" ref={dropdownRef}>
            <button
              className="btn btn-outline-primary fw-bold subbtn dropdown-toggle d-flex align-items-center"
              type="button"
              id="dropdownMenuButton"
              onClick={toggleDropdown}
              style={{ color: 'white' }}
            >
              <i className="bi bi-person-circle me-2"></i>
              <span className="welcome-text">{userName}</span>
            </button>

            {dropdownOpen && (
              <ul className="dropdown-menu dropdown-menu-end show" aria-labelledby="dropdownMenuButton">
                <li>
                  <button className="dropdown-item" onClick={handleLogout}>
                    <i className="bi bi-box-arrow-right me-2"></i>
                    Logout
                  </button>
                </li>
              </ul>
            )}
          </div>
        ) : null}
      </div>
    </nav>
  );
};

export default Navbar;